import React from 'react';
import cc from 'classcat';
import { Transition } from 'react-transition-group';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".react-popup_1-3-1_co-popup {\n  box-sizing: border-box;\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  opacity: 0;\n  visibility: hidden;\n}\n\n.react-popup_1-3-1_co-popup.react-popup_1-3-1_co-popup--small {\n  width: 200px;\n}\n.react-popup_1-3-1_co-popup.react-popup_1-3-1_co-popup--medium, .react-popup_1-3-1_co-popup {\n  width: 300px;\n}\n.react-popup_1-3-1_co-popup.react-popup_1-3-1_co-popup--large {\n  width: 400px;\n}\n.react-popup_1-3-1_co-popup.react-popup_1-3-1_co-popup--compact {\n  display: inline-block;\n  white-space: nowrap;\n  width: auto;\n}\n.react-popup_1-3-1_co-popup.react-popup_1-3-1_co-popup--light, .react-popup_1-3-1_co-popup {\n  background-color: var(--white);\n  color: var(--black);\n}\n.react-popup_1-3-1_co-popup.react-popup_1-3-1_co-popup--dark {\n  background-color: var(--gray-700);\n  color: var(--white);\n}\n.react-popup_1-3-1_co-popup.react-popup_1-3-1_co-popup--error {\n  background-color: var(--error-700);\n  color: var(--white);\n}\n.react-popup_1-3-1_co-popup.react-popup_1-3-1_co-popup--visible, .react-popup_1-3-1_co-popup[data-transition=entered] {\n  opacity: 1;\n  visibility: visible;\n}\n.react-popup_1-3-1_co-popup[data-transition=entering], .react-popup_1-3-1_co-popup[data-transition=exiting] {\n  opacity: 0;\n  visibility: visible;\n}\n.react-popup_1-3-1_co-popup[data-transition=exited] {\n  opacity: 0;\n  visibility: hidden;\n}";
var styles = {
  "co-popup": "react-popup_1-3-1_co-popup",
  "co-popup--small": "react-popup_1-3-1_co-popup--small",
  "co-popup--medium": "react-popup_1-3-1_co-popup--medium",
  "co-popup--large": "react-popup_1-3-1_co-popup--large",
  "co-popup--compact": "react-popup_1-3-1_co-popup--compact",
  "co-popup--light": "react-popup_1-3-1_co-popup--light",
  "co-popup--dark": "react-popup_1-3-1_co-popup--dark",
  "co-popup--error": "react-popup_1-3-1_co-popup--error",
  "co-popup--visible": "react-popup_1-3-1_co-popup--visible"
};
styleInject(css);

const duration = 200;
const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`
};

const getTransitionAttributes = status => ({
  "data-transition": status
});

const classModifiers = {
  small: "co-popup--small",
  medium: "co-popup--medium",
  large: "co-popup--large",
  light: "co-popup--light",
  dark: "co-popup--dark",
  error: "co-popup--error",
  compact: "co-popup--compact"
};

const getModifierClass = modifier => modifier && styles[classModifiers[modifier]];

const Popup = ({
  className = "",
  forwardedRef,
  variation = "light",
  dark,
  size = "medium",
  shape,
  visible,
  style,
  children,
  ...props
}) => {
  const classStyles = [styles["co-popup"], getModifierClass(variation), getModifierClass(size), getModifierClass(shape), {
    [styles["co-popup--dark"]]: dark
  }, className];
  return React.createElement(Transition, {
    in: visible,
    mountOnEnter: true,
    unmountOnExit: true,
    timeout: {
      enter: 0,
      exit: duration
    }
  }, status => React.createElement("div", _extends({
    className: cc(classStyles),
    ref: forwardedRef,
    style: { ...defaultStyle,
      ...style
    }
  }, props, getTransitionAttributes(status), {
    "data-co-name": "Popup",
    "data-co-version": "1.3.1",
    "data-co-project": "cobalt"
  }), status !== "exited" ? children : null));
};

export default Popup;
